import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateConfig } from './config'

import { framework_tool,utils_tool,component_tool } from '@/tool'
import handleFile from "@/utils/downloadExcelUtils";
let { WizContainer, WizReduxTemplate } = framework_tool;
let {  WizBrowserExport } = component_tool;
let { checkStrLength } = utils_tool;

class BankQuestion extends WizContainer {

  componentName = 'BankQuestion';

  constructor(props) {
    super(props);
    const { history } = props
    let mode = 0
    if (history.location && history.location.pathname === '/online/reviewQuestion') {
      mode = 1
    }
    this.state = {
      mode: mode
    }
  }

  _handleFile(columns, nextProps, nextState, key) {
    handleFile.call(this, columns, '检核题目', nextProps, nextState, key)
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let {mode} = this.state
    const _templateConfig = templateConfig({mode})
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile.bind(this, _templateConfig?.content?.params?.columns),
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
      },
      mode: mode
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(BankQuestion);
